/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_CompanyInputs */

const en_mk_foot_company = /** @type {(inputs: Mk_Foot_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company & pricing`)
};

const id_mk_foot_company = /** @type {(inputs: Mk_Foot_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perusahaan & harga`)
};

/**
* | output |
* | --- |
* | "Company & pricing" |
*
* @param {Mk_Foot_CompanyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_company = /** @type {((inputs?: Mk_Foot_CompanyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CompanyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_company(inputs)
	return en_mk_foot_company(inputs)
});